import { Updater } from "use-immer"
// my imports:
import * as Util from "@/app/lib/system/util"
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import WordModule from "@/app/lib/game-state/word-module"
import LetterModule from "@/app/lib/game-state/letter-module"
import UI from "@/app/lib/ui/ui"
import InputHandler from "@/app/lib/input/input-handler"


export function handleKeyDown({
    wordIndex, letterPosition, event, game, ui
} : {
    wordIndex: number,
    letterPosition: number,
    event: React.KeyboardEvent,
    game: AnyGameObj
    ui: UI,
}) {
    if (game.state.freezeInputs()) {
        return;
    }

    event.stopPropagation();

    const wordModule = game.state.words[wordIndex];
    const letterModule = wordModule.letters[letterPosition];
    const key: string = event.key;

    // Initialize a new InputManager
    const input: InputHandler = new InputHandler({
        wordIndex,
        letterPosition,
        game,
        ui
    }); 

    // HANDLE ALPHABETIC KEY PRESSES HERE
    if (Util.isSingleAlphabeticChar(key)) {
        const keyChar: string = key.toLowerCase();

        // if it's an entry slot, allow "onChange"/handleLetterInput to handle it, unless the word is solved
        if (letterModule.type === 'entry'
            && !wordModule.solved
        ) {
            return;
        }

        // Handle any key press on a solved or given box by advancing
        if (
            letterModule.type === 'given'
            || wordModule.solved
        ) {
            input.goNextEntryDelay();
            return;
        }

        // if the key matches the character in our box, advance without updating state
        if (keyChar === letterModule.character) {
            input.goNextEntryDelay();
            return;
        }
    }
    
    // A mapping of keys to their actions
    // refactored from a "switch" so they can all be called in similar fashion...
    // e.g., with preventDefault() as below
    const nonAlphaKeyMap: Map<string, () => void> = new Map([
        [
            " ", 
            () => {
                input.shuffle();
        }],
        [
            "Backspace",
            () => {
                input.backspace();
            }
        ],
        [
            "ArrowLeft",
            () => {
                input.goLeft();
            }
        ],
        [
            "ArrowRight",
            () => {
                input.goRight();
            }
        ],
        [
            "ArrowUp",
            () => {
                input.goUp();
            }
        ],
        [
            "ArrowDown",
            () => {
                input.goDown();
            }
        ],
        [
            "Home",
            () => {
                input.goWordStart();
            }
        ],
        [
            "End",
            () => {
                input.goWordEnd();
            }
        ],
        [
            "Escape",
            () => {
                input.clearWord();
            }
        ]
    ])

    const keyAction = nonAlphaKeyMap.get(key);
    if (keyAction) {
        event.stopPropagation();
        keyAction();
        return;
    }
}